import VueRouter from 'vue-router'

export function createRouter (routes) {
  const router = new VueRouter({
    mode: 'history',
    routes
  })

  router.beforeEach((to, from, next) => {
    console.log('From:', (from && from.path || 'null'), from && from.name ? `(${from.name})` : '', '=> To:', (to && to.path || 'null'), to && to.name ? `(${to.name})` : '')

    // if (to.name === 'object' || to.name === 'vehicle' || to.name === 'employee') {
    // При to.path === '/login' будет to.params.pathMatch === '/login'
    const objectId = (to.params && (to.params.id || to.params.pathMatch)) || null
    if (objectId === 'login') {
      const message = `Ошибка маршрутизации. Неверный идентификатор объекта "${objectId}"`
      router.app.$q.notify({
        type: 'negative',
        message: message,
        progress: true,
        timeout: 4000
      })
      // throw new Error(message)
      console.error(message)
      return
    }

    const matched = to.matched
    if (matched && matched.length && matched[0].name === 'main' && matched.length >= 1 && to.path.startsWith('/main/')) {
      const nextPath = substringMain(to.path)
      next(nextPath)
      return
    }

    next()
  })

  return router
}

export function substringMain (path) {
  if (path.startsWith('/main/')) {
    return path.substring('/main'.length)
  }
  return path
}
